import { AppBar, Box, Button, Dialog, IconButton, Slide, Toolbar, Typography } from "@mui/material";
import ModalComponent from "../../../../Components/ModalComponent";
import React, { useState } from "react";
import { ReactComponent as CloseIcon } from "../../../../Assets/svg/CloseIcon.svg";
import TypeModal from "./TypeModal";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function Reports(props) {


    const [openUsersModal, setOpenUsersModal] = useState(false)

    const [Users, setUsers] = React.useState([]);
    const [UsersLoading, setUsersLoading] = useState(false);

    // const getUsers = (resetState = false) => {
    //     if (resetState) {
    //         setUsers([])
    //         console.log("reset", Users)
    //         setPropKey(propKey => propKey++)
    //         setUserOffset(0);
    //         setHasMoreUsers(true)
    //     }

    //     setUsersLoading(true)
    //     try {
    //         http({
    //             // url of the api endpoint (can be changed)
    //             url: "/users/get-my-users",
    //             method: "GET",
    //             // data: {
    //             //     "Limit": 10,
    //             //     "Offset": UserOffset
    //             // },
    //             headers: {
    //                 "Authorization": `Bearer ${Cookies.get('token')}`
    //             }
    //         }).then((res) => {
    //             console.log("users", res.data.result.Users);

    //             const tmpProp = [...Users]
    //             if (res.data.result.Users.length > 0) {
    //                 if (!resetState) {
    //                     res.data.result.Users.map((item, index) => {
    //                         tmpProp.push(item)
    //                     })
    //                     setUsers(tmpProp)

    //                     setPropKey(propKey => propKey++)
    //                 }
    //                 else
    //                     setUsers(res.data.result.Users)


    //                 setPropKey(propKey => propKey++)

    //             } else {
    //                 console.log("End")
    //                 setHasMoreUsers(false)
    //                 if (resetState) setUsers([])

    //             }

    //             console.log("users ff", Users)
    //             setUsersLoading(false)
    //             setTimeout(function () { setinPlusingUser(true) }, 1000)
    //         });

    //     } catch (e) {
    //         console.error(e);
    //         setUsersLoading(false)

    //     }


    // }
    const handleClickOpenUsersModal = () => {
        // getUsers(true)

        setOpenUsersModal(true);
    };

    const handleOpenUsersModalClose = () => {
        setOpenUsersModal(false);
    };

    const [openTypeModal, setOpenTypeModal] = useState(false)




    return (
        <>
            <ModalComponent
                showModalState={props?.reportModal}
                handleModalClose={props?.handleReportModalClose}
                modalTitle="گزارشات"
                disableSubmitBtn={true}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: "18px" }}>
                    <Button className="tab-nav-item" sx={{ flex: 1 }} onClick={()=>setOpenTypeModal(true)}>ملک</Button>
                    <Button className="tab-nav-item" sx={{ flex: 1 }}>ملک</Button>
                    <Button className="tab-nav-item" sx={{ flex: 1 }}>ملک</Button>
                </Box>



            </ModalComponent>


            {openTypeModal && <TypeModal openTypeModal={openTypeModal} setOpenTypeModal={setOpenTypeModal} />}


            {/* {openUsersModal && <Dialog className="dialog-box"
                fullScreen
                open={openUsersModal}
                onClose={handleOpenUsersModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            کاربران
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleOpenUsersModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                      
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 140px)!important", overflow: "auto" }} id="uset-content">
                    <Box >
                        <Box sx={{ display: "flex", flexDirection: "column", gap: '15px', mt: "15px" }}>
                            {
                                Users && Users.length > 0 ?
                                    Users.map((item, index) => (

                                        <Button className="userItem" sx={{ display: "flex", justifyContent: "space-between", width: "100%", p: 2 }} onClick={() => isLabelOn ? handleSetUserLabel(item) : handleSetUserArchive(item)} key={index}>
                                            <Box sx={{ display: "flex", gap: '5px', alignItems: 'center' }}>
                                                <Box sx={{ bgcolor: "#fff", borderRadius: "50%", width: "40px", height: "40px" }}>
                                                </Box>
                                                <Typography component="span">{item.username}</Typography>
                                            </Box>
                                           
                                        </Button>

                                    ))
                                    : !UsersLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                            }
                            {
                                UsersLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""
                            }

                        </Box>
                    </Box>
                </Box>
                <Button className='green-btn' onClick={handleOpenUsersModalClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>ثبت</Button>
            </Dialog>} */}

           
        </>
    );
}

export default Reports;